import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import '../styles/theme.css';
import '../styles/layout.css';

const DashboardLayout: React.FC = () => {
  const handleNew = () => {
    window.location.href = '/app/new';
  };

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="sidebar-top">
          <div className="sidebar-brand">
            <span className="dot" /> Categorizer
          </div>
          <div className="sidebar-cta">
            <button className="button full" onClick={handleNew}>
              + New Categorization
            </button>
          </div>
        </div>

        <nav className="nav-group">
          <NavLink className={({ isActive }) => `nav-button ${isActive ? 'active' : ''}`} to="/app/dashboard">Dashboard</NavLink>
          <NavLink className={({ isActive }) => `nav-button ${isActive ? 'active' : ''}`} to="/app/category-sets">Category Profiles</NavLink>
          <NavLink className={({ isActive }) => `nav-button ${isActive ? 'active' : ''}`} to="/app/category-jobs">Categorization Jobs</NavLink>
        </nav>

        <div className="sidebar-spacer" />

        <div className="sidebar-bottom">
          <NavLink className={({ isActive }) => `user-row ${isActive ? 'active' : ''}`} to="/app/user-settings">
            <div className="user-avatar" />
            <div style={{ fontWeight: 700 }}>You</div>
          </NavLink>
          <NavLink className={({ isActive }) => `nav-button ${isActive ? 'active' : ''}`} to="/app/settings">Settings</NavLink>
          <NavLink className={({ isActive }) => `nav-button ${isActive ? 'active' : ''}`} to="/app/help">Help</NavLink>
        </div>
      </aside>

      <main className="main">
        <div className="main-header">
          <h2 className="page-title">Categorizer</h2>
        </div>
        <div className="content-card">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout; 